






















import { PropType } from 'vue';
import { IAiStream } from '../types';
import { fmtTime } from '../utils';
import { COLOR_STREAMER_FALLBACK } from '../constants';
import LangChip from './LangChip.vue';
import StatusChip from './StatusChip.vue';

export default {
  name: 'StreamRow',
  components: { LangChip, StatusChip },
  props: {
    stream: {
      type: Object as PropType<IAiStream>,
      required: true
    },
    color: {
      type: String,
      default: COLOR_STREAMER_FALLBACK
    }
  },
  computed: {
    time(): string {
      return `${fmtTime(this.stream.startTime)}-${fmtTime(
        this.stream.endTime
      )}`;
    },
    meta(): string {
      const s = this.stream;
      const parts: string[] = [];
      if (s.defaultBetAmount != null)
        parts.push(`Bet ${s.defaultBetAmount} ${s.currency || ''}`.trim());
      if (s.streamerType) parts.push(String(s.streamerType));
      if (s.streamerId != null) parts.push(`ID ${s.streamerId}`);
      return parts.join(' · ');
    },
    gameNames(): string {
      return this.stream.supportedGames.map(({ name }) => name).join(', ');
    }
  }
};
